<script>
import { useConfigStore, useUserStore } from '~/store/index.ts'

export default {
    name: 'NotificationAlertesPopup',
    props: {
        // data: { type: Object, required: true },
        // translationName: { type: String, required: true },
        // validation: { type: Object, required: false, default: null },
        // validationRules: { type: Object, required: false, default: () => {} },
    },
    emits: [],
    data() {
        const { user } = useUserStore()
        const { currentConfig } = useConfigStore()
        const dept = currentConfig.code_departement
        return {
            alerts: [],
            user,
            currentConfig,
            dept,
        }
    },
    mounted() {
        // GET ACTIVE ALERTS
        if (this.$route.name !== 'connexion') {
            this.$api.setRequest({
                url: 'alerts?filter[where_active]=true&filter[show_website]=true&filter[for_user_territory]=true',
                method: 'GET',
            }).then((res) => {
                this.alerts = res.data
                if (this.alerts.length) {
                    this.$refs.alertesPopup?.showModal()
                }
            })
        }
    },
}
</script>

<template>
    <v-alert
        v-for="alert in alerts"
        :key="alert.id"
        :color="$getColor(`notificationAlert.level.${alert.level}`)"
        elevation="1"
        icon="mdi-alert"
        density="compact"
        class="mb-5"
    >
        <template #title>
            Du {{ $formatDate(alert.start_date) }} <template v-if="alert.end_date">
                au {{ $formatDate(alert.end_date) }}
            </template>
        </template>
        <v-chip v-if="alert.burning_forbidden" variant="flat" size="x-small" color="danger">
            Interdiction de brûlages sur la période
        </v-chip>
        <div>
            {{ alert.description }}
        </div>
    </v-alert>
</template>

<style scoped>
.v-alert.v-alert--border {
    --v-border-opacity: 1 !important;
}
</style>
